module.exports = __webpack_public_path__ + "static/metrics-771df966251e7c8de68309cddd7b5ad2.png";